import { render } from "./CustomDate.vue?vue&type=template&id=79a8f59a&scoped=true"
import script from "./CustomDate.vue?vue&type=script&lang=js"
export * from "./CustomDate.vue?vue&type=script&lang=js"

import "./CustomDate.vue?vue&type=style&index=0&id=79a8f59a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79a8f59a"]])

export default __exports__